export default (id) => id;
//# sourceMappingURL=id.js.map